import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import router from './router';
import './assets/styles.css';
import { trackCurrentPage } from './utils/accessTracker';

Vue.config.productionTip = false;
Vue.use(ElementUI);

router.afterEach(() => trackCurrentPage());
trackCurrentPage();

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
